import { Label, Select, Checkbox } from '@/components/ui'
import { useValuationStore } from '@/store/valuationStore'

const floorOptions = [
  { value: 'interrato', label: 'Piano interrato' },
  { value: 'terra', label: 'Piano terra' },
  { value: 'primo', label: 'Primo piano' },
  { value: 'secondo', label: 'Secondo piano' },
  { value: 'terzo', label: 'Terzo piano' },
  { value: 'quarto', label: 'Quarto piano' },
  { value: 'quinto_o_superiore', label: 'Quinto piano o superiore' },
]

const conditionOptions = [
  { value: 'nuovo', label: 'Nuovo / Mai abitato' },
  { value: 'ristrutturato', label: 'Ristrutturato di recente' },
  { value: 'buono', label: 'Buono stato' },
  { value: 'da_ristrutturare', label: 'Da ristrutturare' },
]

const viewOptions = [
  { value: 'nessuna', label: 'Nessuna vista mare' },
  { value: 'parziale', label: 'Vista mare parziale' },
  { value: 'ampia', label: 'Vista mare panoramica' },
]

export function CharacteristicsStep() {
  const { formData, updateFormData } = useValuationStore()

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Caratteristiche</h2>
        <p className="mt-1 text-gray-600">
          Descrivi le caratteristiche principali dell'immobile
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <Label htmlFor="floor">Piano</Label>
          <Select
            id="floor"
            value={formData.floor || ''}
            onChange={(e) => updateFormData({ floor: e.target.value || undefined })}
            options={floorOptions}
            placeholder="Seleziona il piano"
          />
        </div>

        <div>
          <Label htmlFor="condition">Stato dell'immobile</Label>
          <Select
            id="condition"
            value={formData.condition || ''}
            onChange={(e) => updateFormData({ condition: e.target.value || undefined })}
            options={conditionOptions}
            placeholder="Seleziona lo stato"
          />
        </div>

        <div>
          <Label htmlFor="view">Vista mare</Label>
          <Select
            id="view"
            value={formData.view || ''}
            onChange={(e) => updateFormData({ view: e.target.value || undefined })}
            options={viewOptions}
            placeholder="Seleziona la vista"
          />
        </div>

        <div className="flex items-end pb-2">
          <Checkbox
            id="hasElevator"
            checked={formData.hasElevator || false}
            onChange={(e) => updateFormData({ hasElevator: e.target.checked })}
            label="Presenza di ascensore"
          />
        </div>
      </div>
    </div>
  )
}
